import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { jqxWindowComponent } from 'jqwidgets-ng/jqxwindow';
import { ToastrService } from 'ngx-toastr';
import { CadastroModel } from '../models/cadastro.model';
import { UserInfoModel } from '../models/user-info.model';
import { ContaService } from '../services/conta.service';

@Component({
  selector: 'app-gerenciamento',
  templateUrl: './gerenciamento.component.html',
  styles: [
  ]
})
export class GerenciamentoComponent implements OnInit {
  constructor(private contaService: ContaService, private fb: FormBuilder, private toastrService: ToastrService) { }
  //#region Grid
  @ViewChild('contasGrid') contasGrid: jqxGridComponent;
  contas: UserInfoModel[] = [];
  contaRedefinirSenha: UserInfoModel;

  columns: jqwidgets.GridColumn[] = [
    {
      text: 'E-mail',
      datafield: 'email',
    },
    {
      text: 'Perfil',
      datafield: 'perfil'
    },
    {
      text: '',
      width: 150,
      filterable:false,
      filter:null,
      sortable:false,
      columntype: 'button',
      cellsrenderer: function () {
        return ' Redefinir senha '
      },
      buttonclick: (row: number): void => {
        this.abrirRedefinirSenhaWindow(row);
      },

    },
  ]
  source: jqwidgets.GridSource = {
    type: 'json',
    datafields: [
      { name: 'id' },
      { name: 'email' },
      { name: 'perfil', map: 'perfil>nome' },
    ],
    localdata: null
  }
  gridOptions: jqwidgets.GridOptions = {
    source: null,
    width: "100%", // this.getWidth(),
    columns: this.columns,
    adaptive: false,
    // columngroups: this.columnsGroups,
    theme: "fresh",
    showheader: true,
    autoheight: true,
    sortable: true,
    autofill: true,
    //localization: JqWidgetsConstants.GridLocalization,
    filterable: false,
    filtermode: "default",
    columnsresize: true,
  }
  //#endregion Grid

  //#region Window
  @ViewChild('contaWindow', { static: false }) contaWindow: jqxWindowComponent;
  @ViewChild('redefinirSenhaWindow', { static: false }) redefinirSenhaWindow: jqxWindowComponent;

  contaWindowOptions: jqwidgets.WindowOptions = {
    isModal: true,
    autoOpen: false,
    theme: "fresh"
  }

  redefinirSenhaWindowOptions: jqwidgets.WindowOptions = {
    isModal: true,
    autoOpen: false,
    theme: "fresh"
  }
  //#endregion criarWindow

  //#region Form
  userForm: FormGroup;
  redefinirSenhaForm: FormGroup;
  userData: CadastroModel;
  //#endregion

  ngOnInit(): void {
    this.popularGrid();
    this.criarFormConfig();
    this.redefinirSenhaFormConfig();

  }
  criarFormConfig(): void {
    this.userForm = this.fb.group({
      perfil: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      senha: ['', [Validators.required]],
      confirmarSenha: ['', [Validators.required]]
    });
  }
  redefinirSenhaFormConfig(): void {
    this.redefinirSenhaForm = this.fb.group({
      perfil: new FormControl({ value: "" }, [Validators.required]),
      email: new FormControl({ value: "" }, [Validators.required]),
      senha: ['', [Validators.required]],
      confirmarSenha: ['', [Validators.required]]
    });
  }
  popularGrid() {
    this.contaService.obterContas()
      .subscribe((r) => {
        this.contas = r.data;
        this.source.localdata = this.contas;
        this.gridOptions.source = new jqx.dataAdapter(this.source);
        jqwidgets.createInstance('#contasGrid', 'jqxGrid', this.gridOptions);
      });
  }
  abrirCriarWindow() {
    this.contaWindowOptions.title = 'Criar'
    this.contaWindow.setOptions(this.contaWindowOptions);

    this.contaWindow.open();
  }
  abrirRedefinirSenhaWindow(row) {
    this.contaRedefinirSenha = this.contas[row];

    let perfil = this.contaRedefinirSenha.perfil.nome;
    let email = this.contaRedefinirSenha.email;

    this.redefinirSenhaForm = this.fb.group({
      perfil: [perfil, [Validators.required]],
      email: [email, [Validators.required]],
      senha: ['', [Validators.required]],
      confirmarSenha: ['', [Validators.required]]
    });

    this.redefinirSenhaWindowOptions.title = 'Redefinir senha'
    this.redefinirSenhaWindow.setOptions(this.redefinirSenhaWindowOptions);
    this.redefinirSenhaWindow.open();
  }
  cadastrar() {
    if (this.userForm.dirty && this.userForm.valid) {
      this.userData = Object.assign({}, this.userData, this.userForm.value);
      this.contaService.cadastrar(this.userData)
        .subscribe(
          response => {
            if (response.success) {
              this.toastrService.success("Conta cadastrada!", "Sucesso")
              this.contaWindow.close();
              this.popularGrid();
            }
            else {
              response.errors.forEach(error => {
                //TODO: mostrar no TOASTR
                let toastr = this.toastrService.error(error, 'Erro');

              });
            }
            console.log(response)
          }
        )
    }
  }
  redefinirSenha() {
    if (this.redefinirSenhaForm.dirty && this.redefinirSenhaForm.valid) {
      this.userData = Object.assign({}, this.userData, this.redefinirSenhaForm.value);
      this.contaService.redefinirSenha(this.userData)
        .subscribe(
          response => {
            if (response.success) {
              this.toastrService.success("Senha redefinida!", "Sucesso")
              
              this.redefinirSenhaWindow.close()
            }
            else {
              response.errors.forEach(error => {
                //TODO: mostrar no TOASTR
                let toastr = this.toastrService.error(error, 'Erro');
              });
            }
            console.log(response)
          }
        )
    }
  }
}
